import React from 'react';
import '../../../Styles/Auth/404.css';
import '../../../Styles/AuthForms.css';
import AuthFooter from '../../Auth/AuthFooter';
import { useDowntime } from '../../../contexts/DowntimeContext';

export const DowntimeView: React.FC = () => {
  const { downtime } = useDowntime();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <p className="not-found-message">
          {downtime.message}
        </p>
      </div>
      <AuthFooter />
    </div>
  );
};
